/* js/navMain.js */

jQuery( document ).ready(function( $ ) {

    $('.navMain').dropit();




    $('.js-navMain-trigger').click(function () {
        var $body = $('body');
        $body.toggleClass('nav-open');
        $('.navBar').slideToggle();

        if ( $body.hasClass('nav-open') ) {
            //do something it does have the protected class!
            $('.js-navMain-trigger').text('close');
        }
        else{
            $('.js-navMain-trigger').text('menu');
        }

    });






});